module.exports = __webpack_public_path__ + "img/fabre.8622f3eb.png";